






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Agreement extends Vue {
  private loaded: boolean = false;
  private result: any = "";
  private msOfficeUrl: any =
    "https://view.officeapps.live.com/op/view.aspx?src= ";
  private agreementUrl: any =
    "https://zydata.oss-cn-shanghai.aliyuncs.com/ds/docs/%E5%B2%90%E9%BB%84%E6%95%B0%E6%8D%AEAI%E5%B7%A5%E4%BD%9C%E7%AB%99%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE%281%29.docx";
  private mounted() {
    const url = encodeURI(this.agreementUrl);
    this.result = this.msOfficeUrl + url;
    this.loaded = true;
  }
}
